export const mockHeroDetails = {
    isSponsored: true,
    title: "Timeless product and future classics",
    caption:
        "A new collection of elevated renditions of contemporary classic styles. Garment dyed sport-style sweat crew necks and joggers made from post-consumer materials, hardwearing military-inspired trousers, overshirts and mechanic jackets, and killer cult classics.",
};

export const mockPrimaryDetails = {
    isSponsored: true,
    title: "Party like it’s 2024",
    caption:
        "As we step into the dazzling whirlwind of the party season, there’s no better time to explore the epitome of sartorial excellence that Ferragamo has to offer.",
};
export const mockHeroImageSrcs = {
    mobile: "https://cdna.lystit.com/static/n/static-img/storybook/hero/mobile.jpeg",
    desktop: "https://cdna.lystit.com/static/n/static-img/storybook/hero/desktop.jpeg",
};
export const mockPrimaryImageSrcs = {
    mobile: "https://cdna.lystit.com/static/n/static-img/storybook/primary-callout/mobile.jpg",
    desktop: "https://cdna.lystit.com/static/n/static-img/storybook/primary-callout/desktop.jpg",
};
